import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import Diplomas from '@app/components/parents/Diplomas'
import Loader from '@app/components/ui/placeholders/Loader'
import * as parentActions from '@app/actions/parents'

class DiplomasContainer extends Component {
  componentDidMount() {
    this.updateIfNeeded()
  }

  updateIfNeeded() {
    const { global: { event: { id } } } = this.props
    this.props.boundActions.fetchDiplomasIfNeeded(id)
  }

  render() {
    const { diplomas, global: { event: { id } } } = this.props
    if (!diplomas[id] && diplomas.fetching) { return <Loader /> }

    return ( <Diplomas diplomas={diplomas} event_id={id} /> )
  }
}

const mapStateToProps = (state) => {
  const { parents: { diplomas } } = state;
  return { diplomas }
}

const mapDispatchToProps = (dispatch) => {
  const boundActions = bindActionCreators(parentActions, dispatch)
  return { boundActions }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null, {
    getDisplayName: () => 'Diplomas'
  }
)(DiplomasContainer)
